// PRD.317 — PowerSync queries for diagnosis tooth context.
//
// Split from `diagnosis-teeth-logic.ts` (identity, grouping, diffing) because
// that module must stay import-free to run under the node:test harness.

import type { QuerySpec } from '@helios/powersync-client-core';

export * from './diagnosis-teeth-logic.js';

/**
 * All tooth associations for one encounter, in one read.
 *
 * Encounter-scoped rather than per-diagnosis so the section issues a single
 * watched query and groups client-side via `groupTeethByDiagnosis`.
 */
export function qDiagnosisTeethByEncounter(encounterId: string): QuerySpec<[string]> {
  return {
    key: ['patient_diagnosis_teeth', 'by-encounter', encounterId] as const,
    sql: `SELECT * FROM patient_diagnosis_teeth WHERE encounter_id = ?`,
    params: [encounterId],
    watch: ['patient_diagnosis_teeth'],
  };
}
